import React from 'react'



const SmallButton = ({children ,onClick}) => {



  return (
    <div class="relative inline-flex  group"  onClick={onClick}>
    <div
        class="absolute transitiona-all duration-1000 opacity-20 dark:opacity-35 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#0063E9] to-[#2F70E4] rounded-xl blur-lg group-hover:opacity-40 dark:group-hover:opacity-50 group-hover:-inset-1 group-hover:duration-200 animate-tilt">
    </div>
   <button className="bg-gradient-to-bl text-light-link dark:text-dark-link from-light-glass1 dark:from-dark-glass1 to-light-glass2 dark:to-dark-glass2 backdrop:blur-xl shadow-xl  border-2 border-light-secondary dark:border-dark-glassStrock1 rounded-full items-center flex justify-center"
 >
{children}
</button>

    </div>
  )
}

export default SmallButton